_STATUS = $('.pg_statusinfo');
function check_status(){
  
var pin = $('#PIN').val();
_STATUS.eq(0).html('');


  
	var url='http://design.postergully.com/pincodes/pincode.php';
 $.ajax({
		url:url,
	type:'get',
	dataType:'jsonp',
	beforeSend:function(){
		$('button#isCOD').html('Checking...');
	},
	success:function(response){
if(response[pin] == 'NO' || response[pin] == undefined){
 _STATUS.eq(0).html('&#10006; Cash on Delivery is NOT AVAILABLE at your location. Please complete your purchase using Credit Card, Debit Card or Netbanking');
					_STATUS.eq(0).css('color', 'red');
      }
      else{
        _STATUS.eq(0).html('&#10004; Cash on Delivery is AVAILABLE at your location');
  _STATUS.eq(0).css('color', 'green');  
      } 
	},
	complete:function(){
		$('button#isCOD').html('Check');
	},
	error:function(xhr, ajaxOptions, thrownError){
		console.log(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
	}
	});
  


	
}
function checkstatus(){ 

  var city=$('#pg_city').val();
  
   var delivery_time={"bgl":"2","mum":"2","ndl":"2","pun":"5","gur":"2","chn":"5","hyd":"5","kol":"8","nod":"2","amd":"5","jpr":"2","lko":"2","gut":"8","gzb":"2","chd":"2","ldn":"2","mpl":"5","drd":"5","tvd":"10","nec":"10","oth":"5","itc":"8"};
  var dispatch_time={"9911613":"6","7319889":"1","11796021":"2","9724631":"7","23013133":"3","24784161":"3","15132701":"7","24006997":"3","15721261":"1","11982121":"11","9004130":"5","14304269":"5","7223853":"1","10016795":"4","11498547":"1","7223851":"1"};
  var time_codes={"1":"1","2":"1-2","3":"1-3","4":"2","5":"2-3", "6":"2-4", "7":"3","8":"3-4","9":"3-5","10":"4-5","11":"4-6","12":"4-7","13":"7-10"};
 
  var big="0";
  if($('#pg_product_type').length == 0)
  {
    
   $.each($('#cartform ul li'),function(index,data){
    
    if(parseInt(dispatch_time[$(data).data('itemtype')])> parseInt(big) )
      big=[$(data).data('itemtype')];
    
  });
  }
  else
  { 
  big=$('#pg_product_type').val();
  }
  if(big != "" && city != ""){
    if(big == "0" )
  _STATUS.eq(1).html( '<span style="width:45%;display:inline-block;margin-right:10px;vertical-align:top;"><span style="color:red;">&#10006;</span> No products in your cart</span><span style="width:45%;display:inline-block;vertical-align:top;"><span style="color:blue;">&#10004;</span> Estimated time for delivery (after dispatch) is '+time_codes[delivery_time[city]]+' working day(s)</span>');     
      else{
        
    _STATUS.eq(1).html( '<span style="width:45%;display:inline-block;margin-right:10px;vertical-align:top;"><span style="color:blue;">&#10004;</span> Estimated time for dispatch is '+time_codes[dispatch_time[big]]+' working day(s)</span><span style="width:45%;display:inline-block;vertical-align:top;"><span style="color:blue;">&#10004;</span> Estimated time for delivery (after dispatch) is '+time_codes[delivery_time[city]]+' working day(s)</span>');
   
        _STATUS.eq(1).css('color','black'); 
  }
}
  else
  { _STATUS.eq(1).html('Please select a city');  }
  
}
var timeoutid;
$('#PIN').click(function (){$(this).val('');});
$('#isCOD').click(function (){check_status();});
$('#shipping-calculate').click(function(){
  _STATUS.eq(1).html('<img src="//hahaha-23.myshopify.com/cdn/shop/t/7/assets/loader.gif?v=37702279038218273241441864879"/> Calculating estimated time');
  _STATUS.eq(1).css('color','black');
  timeoutid= window.setTimeout(function(){ window.clearTimeout(timeoutid);checkstatus(); },1000);
}); 